import { render, staticRenderFns } from "./AdicionarItensNotaFiscal.vue?vue&type=template&id=15125b39&scoped=true"
import script from "./AdicionarItensNotaFiscal.vue?vue&type=script&lang=js"
export * from "./AdicionarItensNotaFiscal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15125b39",
  null
  
)

export default component.exports